import { render } from "./EmailSettingsForm.vue?vue&type=template&id=7287964d&scoped=true"
import script from "./EmailSettingsForm.vue?vue&type=script&lang=js"
export * from "./EmailSettingsForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/whisk/whisk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7287964d"]])

export default __exports__